import React from 'react';
import { TextField as TdsTextField } from '@tesla/react-tds/global';
import useFormField from '../../hooks/useFormField';

export default function Input(props) {
  const { defaultHandler, formFieldContext, render, userProps, formFieldRef } = useFormField(props);

  return render(
    <TdsTextField
      {...defaultHandler}
      error={formFieldContext.$showError}
      errorLabel={formFieldContext.error}
      {...userProps}
      ref={formFieldRef}
    />
  );
}

Input.propTypes = {};
